import commonConstant from '../../common/_commonConstant';

export const getParkingProblems = (state, action) => {
  switch (action.type) {
    case commonConstant.GET_PARKING_PROBLEMS_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.GET_PARKING_PROBLEMS_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};

export const getProblems = (state, action) => {
  switch (action.type) {
    case commonConstant.GET_PROBLEMS_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.GET_PROBLEMS_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};

export const createProblem = (state, action) => {
  switch (action.type) {
    case commonConstant.CREATE_PROBLEM_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.CREATE_PROBLEM_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};

export const updateProblem = (state, action) => {
  switch (action.type) {
    case commonConstant.UPDATE_PROBLEM_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.UPDATE_PROBLEM_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};

export const deleteProblem = (state, action) => {
  switch (action.type) {
    case commonConstant.DELETE_PROBLEM_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.DELETE_PROBLEM_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};
